<template>
  <div v-if="teams.length > 0 && stadiums.length > 0">
    <div class="md-layout">
      <div class="md-layout-item"> 
        <h3>{{$t('games.form.edit')}}</h3>
      </div>
    </div>
    <div class="container md-layout">
      <div class="md-layout-item md-size-60">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="card-icon">
              <md-icon>sports_soccer</md-icon>
            </div>
            <h4 class="title">{{$t('games.form.info')}}</h4>
          </md-card-header>

          <md-card-content>
            <!-- LocalId -->
            <md-field :class="{'md-error': $v.gameUpdate.localId.$error && $v.gameUpdate.localId.$invalid, 'md-valid': !$v.gameUpdate.localId.$error && !$v.gameUpdate.localId.$invalid}">
              <label for="teamLocal">{{$t('games.form.teamLocal')}}</label>
              <md-select v-model="$v.gameUpdate.localId.$model" name="teamLocal" id="teamLocal">
                <md-option v-for="(team, idxTeam) in teams" :key="idxTeam" :value="team.id" v-show="$v.gameUpdate.visitorId.$model != team.id">{{team.name}}</md-option>
              </md-select>
            </md-field>
            <!-- VisitorId -->
            <md-field :class="{'md-error': $v.gameUpdate.visitorId.$error && $v.gameUpdate.visitorId.$invalid, 'md-valid': !$v.gameUpdate.visitorId.$error && !$v.gameUpdate.visitorId.$invalid}">
              <label for="teamVisitor">{{$t('games.form.teamVisitor')}}</label>
              <md-select v-model="$v.gameUpdate.visitorId.$model" name="teamVisitor" id="teamVisitor">
                <md-option v-for="(team, idxTeam) in teams" :key="idxTeam" :value="team.id" v-show="$v.gameUpdate.localId.$model != team.id">{{team.name}}</md-option>
              </md-select>
            </md-field>
            <!-- ScheduleMatchDate -->
            <md-datepicker v-model="$v.gameUpdate.date.date.$model" md-immediately :class="{'md-error': $v.gameUpdate.date.date.$error && $v.gameUpdate.date.date.$invalid, 'md-valid': !$v.gameUpdate.date.date.$error && !$v.gameUpdate.date.date.$invalid}">
              <label>{{$t('games.form.matchDate')}}</label>
            </md-datepicker>
            <md-field :class="{'md-error': $v.gameUpdate.date.hour.$error && $v.gameUpdate.date.hour.$invalid, 'md-valid': !$v.gameUpdate.date.hour.$error && !$v.gameUpdate.date.hour.$invalid}">
              <label>{{$t('games.form.matchHour')}}</label>
              <md-select v-model="$v.gameUpdate.date.hour.$model" name="hour" id="hour">
                <md-option v-for="(hour, idxHour) in 24" :key="`idxHour-${idxHour}`" :value="timeValue(hour - 1)">{{timeValue(hour - 1)}}</md-option>
              </md-select>
            </md-field>
            <md-field :class="{'md-error': $v.gameUpdate.date.minutes.$error && $v.gameUpdate.date.minutes.$invalid, 'md-valid': !$v.gameUpdate.date.minutes.$error && !$v.gameUpdate.date.minutes.$invalid}">
              <label>{{$t('games.form.matchMinutes')}}</label>
              <md-select v-model="$v.gameUpdate.date.minutes.$model" name="hour" id="hour">
                <md-option v-for="(minutes, idxMinutes) in 60" :key="`idxMinutes-${idxMinutes}`" :value="timeValue(minutes - 1)">{{timeValue(minutes - 1)}}</md-option>
              </md-select>
            </md-field>
            <!-- Description -->
            <md-field :class="{'md-error': $v.gameUpdate.description.$error && $v.gameUpdate.description.$invalid, 'md-valid': !$v.gameUpdate.description.$error && !$v.gameUpdate.description.$invalid}">
              <label>{{$t('games.form.description')}}</label>
              <md-input v-model.trim="$v.gameUpdate.description.$model"></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="$v.gameUpdate.description.$error && $v.gameUpdate.description.$invalid">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="!$v.gameUpdate.description.$error && !$v.gameUpdate.description.$invalid">done</md-icon>
              </slide-y-down-transition>
            </md-field>
            <!-- Stadium -->
            <md-field :class="{'md-error': $v.gameUpdate.stadiumId.$error && $v.gameUpdate.stadiumId.$invalid, 'md-valid': !$v.gameUpdate.stadiumId.$error && !$v.gameUpdate.stadiumId.$invalid}">
              <label for="stadium">{{$t('games.form.stadium')}}</label>
              <md-select v-model="$v.gameUpdate.stadiumId.$model" name="stadium" id="stadium">
                <md-option v-for="(stadium, idxStadium) in stadiums" :key="idxStadium" :value="stadium.id">{{stadium.name}}</md-option>
              </md-select>
            </md-field>
            <!-- Season -->
            <md-field :class="{'md-error': $v.gameUpdate.seasonId.$error && $v.gameUpdate.seasonId.$invalid, 'md-valid': !$v.gameUpdate.seasonId.$error && !$v.gameUpdate.seasonId.$invalid}">
              <label for="season">{{$t('games.form.season')}}</label>
              <md-select v-model="$v.gameUpdate.seasonId.$model" name="season" id="season">
                <md-option v-for="season in listSeasons" :key="season.id" :value="season.id">{{season.name}}</md-option>
              </md-select>
            </md-field>
            <!-- Match day -->
            <md-field :class="{'md-error': $v.gameUpdate.matchday.$error && $v.gameUpdate.matchday.$invalid, 'md-valid': !$v.gameUpdate.matchday.$error && !$v.gameUpdate.matchday.$invalid}">
              <label>{{$t('games.form.matchday')}}</label>
              <md-input v-model.trim="$v.gameUpdate.matchday.$model"></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="$v.gameUpdate.matchday.$error && $v.gameUpdate.matchday.$invalid">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="!$v.gameUpdate.matchday.$error && !$v.gameUpdate.matchday.$invalid">done</md-icon>
              </slide-y-down-transition>
            </md-field>
            <!-- Picture -->
            <md-card class="md-layout-item md-size-50">
              <md-card-header-text>
                <h4>{{ $t("games.form.picture") }}</h4>
              </md-card-header-text>
              <md-card-media-actions>
                <md-card-media class="image-preview">
                  <img v-if="$v.gameUpdate.picture.$model != ''" :src="getUrlImage($v.gameUpdate.picture.$model)" alt="Live preview">
                  <img v-else src="/img/placeholder-ff21.jpg" alt="Live preview default">
                </md-card-media>

                <md-card-actions>
                  <md-button class="md-simple">
                    <label for="upload-picture">
                      <md-file @md-change="uploadPicture" name="upload-picture" id="upload-picture" style="display: none"></md-file>
                      <md-icon>edit</md-icon> Editar
                    </label>
                  </md-button>
                </md-card-actions>
              </md-card-media-actions>
            </md-card>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-size-40">
        <!-- STREAM -->
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="card-icon">
              <md-icon>sports_soccer</md-icon>
            </div>
            <h4 class="title">{{$t('games.form.stream')}}</h4>
          </md-card-header>
          <md-card-content>
            <!-- StreamingUrlLocal -->
            <md-field :class="{'md-error': $v.gameUpdate.streamingUrlLocal.$error && $v.gameUpdate.streamingUrlLocal.$invalid, 'md-valid': !$v.gameUpdate.streamingUrlLocal.$error && !$v.gameUpdate.streamingUrlLocal.$invalid}">
              <label>{{$t('games.form.streamingUrlLocal')}}</label>
              <md-input v-model.trim="$v.gameUpdate.streamingUrlLocal.$model"></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="$v.gameUpdate.streamingUrlLocal.$error && $v.gameUpdate.streamingUrlLocal.$invalid">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="!$v.gameUpdate.streamingUrlLocal.$error && !$v.gameUpdate.streamingUrlLocal.$invalid">done</md-icon>
              </slide-y-down-transition>
            </md-field>
            <!-- StreamingUrlVisitor -->
            <md-field :class="{'md-error': $v.gameUpdate.streamingUrlVisitor.$error && $v.gameUpdate.streamingUrlVisitor.$invalid, 'md-valid': !$v.gameUpdate.streamingUrlVisitor.$error && !$v.gameUpdate.streamingUrlVisitor.$invalid}">
              <label>{{$t('games.form.streamingUrlVisitor')}}</label>
              <md-input v-model.trim="$v.gameUpdate.streamingUrlVisitor.$model"></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="$v.gameUpdate.streamingUrlVisitor.$error && $v.gameUpdate.streamingUrlVisitor.$invalid">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="!$v.gameUpdate.streamingUrlVisitor.$error && !$v.gameUpdate.streamingUrlVisitor.$invalid">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </md-card-content>
        </md-card>
        <!-- TICKETERA -->
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="card-icon">
              <md-icon>sports_soccer</md-icon>
            </div>
            <h4 class="title">{{$t('games.form.ticketera')}}</h4>
          </md-card-header>
          <md-card-content>
            <!-- PaidMatch -->
            <md-switch v-model="withTicketera">{{$t('games.form.withTicketera')}}</md-switch>
            <!-- LocalTicketBuyLink -->
            <md-field :class="{'md-error': $v.gameUpdate.localTicketBuyLink.$error && $v.gameUpdate.localTicketBuyLink.$invalid, 'md-valid': !$v.gameUpdate.localTicketBuyLink.$error && !$v.gameUpdate.localTicketBuyLink.$invalid}">
              <label>{{$t('games.form.localTicketBuyLink')}}</label>
              <md-input :disabled="!withTicketera" v-model.trim="$v.gameUpdate.localTicketBuyLink.$model"></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="$v.gameUpdate.localTicketBuyLink.$error && $v.gameUpdate.localTicketBuyLink.$invalid">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="!$v.gameUpdate.localTicketBuyLink.$error && !$v.gameUpdate.localTicketBuyLink.$invalid">done</md-icon>
              </slide-y-down-transition>
            </md-field>
            <!-- VisitorTicketBuyLink -->
            <md-field :class="{'md-error': $v.gameUpdate.visitorTicketBuyLink.$error && $v.gameUpdate.visitorTicketBuyLink.$invalid, 'md-valid': !$v.gameUpdate.visitorTicketBuyLink.$error && !$v.gameUpdate.visitorTicketBuyLink.$invalid}">
              <label>{{$t('games.form.visitorTicketBuyLink')}}</label>
              <md-input :disabled="!withTicketera" v-model.trim="$v.gameUpdate.visitorTicketBuyLink.$model"></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="$v.gameUpdate.visitorTicketBuyLink.$error && $v.gameUpdate.visitorTicketBuyLink.$invalid">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="!$v.gameUpdate.visitorTicketBuyLink.$error && !$v.gameUpdate.visitorTicketBuyLink.$invalid">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </md-card-content>
        </md-card>
        <!-- ADMIN -->
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="card-icon">
              <md-icon>sports_soccer</md-icon>
            </div>
            <h4 class="title">{{$t('games.form.admin')}}</h4>
          </md-card-header>
          <md-card-content>
            <!-- Admins -->
            <md-field :class="{'md-error': $v.gameUpdate.admins.$error && $v.gameUpdate.admins.$invalid, 'md-valid': !$v.gameUpdate.admins.$error && !$v.gameUpdate.admins.$invalid}">
              <label for="admins">{{$t('games.form.admins')}}</label>
              <md-select v-model="$v.gameUpdate.admins.$model" name="admins" id="admins" multiple>
                <md-option v-for="(user, idxUser) in listUsers" :value="user.id" :key="idxUser">{{user.firstName}} {{user.lastName}}</md-option>
              </md-select>
              <slide-y-down-transition>
                <md-icon class="error" v-show="$v.gameUpdate.admins.$error && $v.gameUpdate.admins.$invalid">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="!$v.gameUpdate.admins.$error && !$v.gameUpdate.admins.$invalid">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item">
        <md-button @click="updateGame" class="md-info md-block" :disabled="loading">
          {{$t('games.form.edit')}}
        </md-button>
      </div>
    </div>
  </div>
</template>

<script>
import storage from "@/plugins/azure-storage";
import { required, email, sameAs, numeric } from 'vuelidate/lib/validators';
import { SlideYDownTransition } from "vue2-transitions";
import { mapState } from 'vuex';
import moment from 'moment';

window.moment = moment;

export default {
  components: {
    SlideYDownTransition
  },
  computed: {
    ...mapState({
      teams: state => state.StuffModule.teams,
      stadiums: state => state.StuffModule.stadiums,
      listUsers: state => state.SecurityModule.listUsers,
      listSeasons: state => state.StuffModule.seasons
    })
  },
  data() {
    return {
      loading: false,
      gameUpdate: {},
      withTicketera: false
    }
  },
  async mounted() {
    let gameUpdate = await this.$store.dispatch("get4Update", {id: this.$route.params.id})
    if (gameUpdate) {
      gameUpdate.date = {
        date: moment(gameUpdate.scheduledMatchDate).format('DD/MM/YYYY'),
        hour: moment(gameUpdate.scheduledMatchDate).format('hh'),
        minutes: moment(gameUpdate.scheduledMatchDate).format('mm')
      }
      this.withTicketera = gameUpdate.visitorPaid && gameUpdate.localPaid
      this.gameUpdate = gameUpdate
      if(this.teams.length == 0) this.$store.dispatch('teamsGet')
      if(this.stadiums.length == 0) this.$store.dispatch('getStadiums')
      if(this.listUsers.length == 0) this.$store.dispatch('usersGet')
      if(this.listSeasons.length == 0) this.$store.dispatch('seasonsGet')
    } else {
      this.$store.dispatch("openModalError")
      this.$router.push("/list/games")
    }
  },
  beforeMount() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy'
  },
  methods: {
    async updateGame() {
      this.$v.$touch();
      console.log(this.$v);
      if (!this.$v.$invalid) {
        let model = this.gameUpdate;
        model.id = this.$route.params.id;
        model.scheduledMatchDate = `${moment(this.gameUpdate.date.date, 'DD/MM/YYYY').format('YYYY-MM-DD')}T${this.gameUpdate.date.hour}:${this.gameUpdate.date.minutes}:00.000`,
        model.visitorPaid = this.withTicketera
        model.localPaid = this.withTicketera
        
        this.loading = true;
        const response = await this.$store.dispatch("update", model);
        if (response != undefined) {
          this.$notify({
            message: this.$t(`notifications.game.update`),
            icon: 'add_alert',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'success'
          })
        } else {
          this.$store.dispatch("openModalError")
        }
        this.$router.push("/list/games");
        this.loading = false;
        return;
      } else {
        return;
      }
    },
    async uploadPicture(FileList) {
      const file = FileList[0];
      this.loading = true;
      const fileName = await storage.updateFile({
        file,
        container: process.env.VUE_APP_CDN_CONTAINER_GAME_PICTURES
      });

      this.gameUpdate.picture = fileName;
      this.$v.gameUpdate.picture.$touch();
      this.loading = false;

      return;
    },
    timeValue(str) {
      if (Number(str) >= 0 && Number(str) <= 9) {
        return `0${str}`;
      } else {
        return str;
      }
    },
    getUrlImage(path) {
      return `${process.env.VUE_APP_CDN_URL_GAME_PICTURES}${path}`
    }
  },
  validations: {
    gameUpdate: {
      localId: {
        required
      },
      visitorId: {
        required
      },
      date: {
        date: {
          required
        },
        hour: {
          required
        },
        minutes: {
          required
        }
      },
      description: {
        required
      },
      stadiumId: {
        required
      },
      seasonId: {
        required
      },
      matchday: {
        required,
        numeric
      },
      picture: {
        required
      },
      streamingUrlLocal: {},
      streamingUrlVisitor: {},
      localTicketBuyLink: {},
      visitorTicketBuyLink: {},
      admins: {}
    }
  }
}
</script>
